import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteAnimalCategoriaCadastro } from '../service';
import {
    DELETE_ANIMAL_CATEGORIA_CADASTRO,
  DELETE_ANIMAL_CATEGORIA_CADASTRO_PENDING,
  DELETE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS,
  DELETE_ANIMAL_CATEGORIA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeleteAnimalCategoriaCadastro(action) {
  yield put({ type: DELETE_ANIMAL_CATEGORIA_CADASTRO_PENDING, id: action.id })

  try {
    const a = yield call(deleteAnimalCategoriaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_ANIMAL_CATEGORIA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_ANIMAL_CATEGORIA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteAnimalCategoriaCadastro() {
  yield takeLatest(DELETE_ANIMAL_CATEGORIA_CADASTRO, sagaDeleteAnimalCategoriaCadastro)
}
